export const API_BASE_URL: string = process.env.REACT_APP_TIOTE_API_ENDPOINT!
export const VAPID_PUBLIC_KEY: string = process.env.REACT_APP_VAPID_PUBLIC_KEY!
export const SUPPORTED_LOCALES: string[] = ['fr', 'en']
export const DEFAULT_LOCALE: string = 'fr'
